<div class="Container">
    <!-- <div class="imageContainer">
        <span class="arrow" (click)="previousImage()" style="cursor: pointer;">
            < </span>
                <img class="image" [src]="image" alt="" *ngIf="image">
                <img class="image" src="../.../../../../../assets/image/facultyTracking/imageIcon.svg" alt=""
                    *ngIf="!image">
                <span class="arrow" (click)="nextImage()" style="cursor: pointer;">></span>
    </div> -->

    <div class="image-section">
        <button class="nav-btn prev">
            <mat-icon (click)="previousImage()">chevron_left</mat-icon>
        </button>
        <div class="image-wrapper">
            <img [src]="image" *ngIf="image" [style.transform]="'rotate(' + rotation + 'deg)'" alt=" Classroom">
            <img class="image" src="../.../../../../../assets/image/facultyTracking/imageIcon.svg" alt=""
                *ngIf="!image">
            <div class="image-footer">
                <span class="date">{{ date }}</span>
                <button class="rotate-btn" (click)="rotateImage()">
                    <span>Rotate image</span>
                    <mat-icon>cached</mat-icon>
                </button>
            </div>
        </div>
        <button class="nav-btn next">
            <mat-icon (click)="nextImage()">chevron_right</mat-icon>
        </button>
    </div>

    <!-- <div class="detailsContainer"> -->
    <!-- <div class="titleContainer">
            <span class="title">{{data.teacher}}</span>
            <span class="subTitle">{{data.section}}</span>
        </div> -->

    <!-- <div class="dataContainer">
            <span class="data"><img src="../../../../assets/image/facultyTracking/groupIcon.svg" alt=""> Student count:
                40</span>
            <span class="data"><img src="../../../../assets/image/facultyTracking/iconamoon_clock-light.svg" alt="">
                Date : {{date}}</span>
            <span class="data"><img src="../../../../assets/image/facultyTracking/iconamoon_clock-light.svg" alt="">
                Start time: {{ startTime}}</span>
            <span class="data"><img src="../../../../assets/image/facultyTracking/iconamoon_clock-light.svg" alt=""> End
                time: {{ endTime}}</span>
            <span class="data"><img src="../../../../assets/image/facultyTracking/iconamoon_clock-light.svg" alt="">
                Duration: {{data.duration}}</span>
        </div> -->


    <div class="details-section">
        <div class="header-row">
            <div class="faculty-subject">
                <span class="label">Faculty :</span>
                <span class="value">{{ data.teacher }}</span>
                <span class="separator">|</span>
                <span class="label">Subject :</span>
                <span class="value">{{ data.subject }}</span>
            </div>
            <div class="badges">
                <span class="badge section">{{ data.sectionName }}</span>
                <span class="badge period">{{ data.period }}</span>
            </div>
        </div>



        <!-- <div class="info-grid">

            <div class="info-item">
                <mat-icon>menu_book</mat-icon>
                <div class="info-text">
                    <span class="label">Topic :</span>
                    <span class="value">{{ data.topicName }}</span>
                </div>
            </div>

            <div class="info-item">
                <mat-icon>menu_book</mat-icon>
                <div class="info-text">
                    <span class="label">Sub Topic :</span>
                    <span class="value">{{ data.subTopicName }}</span>
                </div>
            </div>

        </div> -->



        <div class="info-grid">
            <div class="info-item">
                <mat-icon>menu_book</mat-icon>
                <div class="text-block">
                    <span class="label">Topic :</span>
                    <span class="value">{{ data.topicName }}</span>
                </div>
            </div>

            <div class="info-item">
                <mat-icon>menu_book</mat-icon>
                <div class="text-block">
                    <span class="label">Sub Topic :</span>
                    <span class="value">{{ data.subTopicName }}</span>
                </div>
            </div>
        </div>
        <div class="period-info">

            <div class="info-block">
                <mat-icon>access_time</mat-icon>
                <span class="label">Period Start Time:</span>
                <span class="value">{{ startTime }}</span>
            </div>

            <div class="info-block">
                <mat-icon>access_time</mat-icon>
                <span class="label">Period End Time:</span>
                <span class="value">{{ endTime }}</span>
            </div>

            <div class="info-block">
                <mat-icon>groups</mat-icon>
                <span class="label">Student Count:</span>
                <span class="value">{{ data.studentCount }}/{{ data.sectionStudentCount}}</span>
            </div>

        </div>



    </div>

    <!-- </div> -->
    <div class="buttonContainer">
        <button class="button" (click)="close()">close</button>
    </div>
</div>


<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>